export default __webpack_public_path__ + "static/media/19-idea-napkin.66977587.svg";